const projects = [
    {
        title: 'power sink',
        publisher: 'winterwire games',
        roles: [
            { role: 'composer' },
            { role: 'sound designer' },
            { role: 'fmod implementation' },
        ],
        published: '22.05.2025',
        description: 'Descend into the ruins of a submerged power plant, where flickering lights and corroded machinery guard long-buried secrets. Restore power, uncover the past, and navigate the depths—but beware what lurks below.',
        banner: `${process.env.PUBLIC_URL}/images/banners/power-sink-banner.png`,
        screenshots: [
            { url: `${process.env.PUBLIC_URL}/images/screenshots/power-sink/1.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/power-sink/2.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/power-sink/3.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/power-sink/4.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/power-sink/5.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/power-sink/6.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/power-sink/7.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/power-sink/8.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/power-sink/9.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/power-sink/10.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/power-sink/11.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/power-sink/12.jpg` },
        ],
        videos: [
            { name: 'trailer', url: 'https://www.youtube.com/embed/lhUpXxP4xd4?si=RXY106x7ajBnshXs' },
            { name: 'trailer', url: 'https://www.youtube.com/embed/cRyxGduZacM?si=gBiSYzVcg3yY8Lh9' },
            { name: 'trailer', url: 'https://www.youtube.com/embed/wtMIyUy98js?si=5L2eOIRwHi-xTXYN' },
        ],
        audio: [
            { url: 'https://open.spotify.com/embed/album/4pAz8F9LSjUKK3jF174jIP?utm_source=generator&theme=0' }
            // { url: 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1680830433&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true' }
        ],
        link: 'https://store.steampowered.com/app/2289740/Power_Sink/'
    },
    {
        title: 'misc. a tiny tale',
        publisher: 'tinyware games',
        roles: [
            { role: 'voice actor' },
            { role: 'sound designer' },
            { role: 'incidental music composer' }

        ],
        published: '31.07.2025',
        description: 'Meet Buddy and Bag Boy – two tiny robots with big hearts and an even bigger mission: spreading joy! After a mysterious explosion rains golden cogs and trash from the sky, it’s their job to collect, clean, and help each village while uncovering the secret behind the blast.',
        banner: `${process.env.PUBLIC_URL}/images/banners/misc-banner.jpg`,
        screenshots: [
            { url: `${process.env.PUBLIC_URL}/images/screenshots/misc/1.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/misc/2.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/misc/3.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/misc/4.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/misc/5.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/misc/6.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/misc/7.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/misc/8.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/misc/9.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/misc/10.jpg` },
        ],
        videos: [
            { name: 'trailer', url: 'https://www.youtube.com/embed/pUrBcXf5j9o?si=c-r76196RALGcUCY' },
            { name: 'trailer', url: 'https://www.youtube.com/embed/3y0j45t3aKc?si=YaF6c0IFHYeUOF7G' },
            { name: 'trailer', url: 'https://www.youtube.com/embed/KrFINLAWUBA?si=_WQw_A7M1-Tagl9s' },
        ],
        link: 'https://store.steampowered.com/app/1308940/Misc_A_Tiny_Tale/'
    },
    {
        title: 'span',
        publisher: 'space base place',
        roles: [
            { role: 'composer' },
            { role: 'fmod implementation' }
        ],
        published: 'TBA',
        description: 'Explore, create, and defend humanity from the machine onslaught in this fast-paced survival adventure. Navigate an ancient space megastructure, master a powerful tether system for traversal and combat, and use a detailed building system to construct epic bases. Play solo or with friends in co-op multiplayer, enduring hazardous environments and relentless AI-controlled sieges as you race to uncover the mysteries of the SPAN.',
        banner: `${process.env.PUBLIC_URL}/images/banners/span-banner.jpg`,
        videos: [
            { name: 'trailer', url: 'https://www.youtube.com/embed/QumUPzD-HTU?si=r7BFcNSjX8RP4l37' },
            { name: 'gameplay', url: 'https://www.youtube.com/embed/64I8HEUi024?si=PA-Rp-Khz3IQZncy' },
        ],
        audio: [
            { url: 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1988678028&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true' }
        ],
        link: ''
    },
    {
        title: 'archery evolution',
        publisher: 'vhite rabit xr',
        roles: [
            { role: 'composer' },
            { role: 'sound designer' }
        ],
        published: 'TBA',
        description: 'Prove Your Aim in Archery Evolution, a VR sci-fi archery experience. Face off friends in online multiplayer or test your skills in time trials!',
        banner: `${process.env.PUBLIC_URL}/images/banners/archevo-banner.png`,
        videos: [
            { name: 'trailer', url: 'https://www.youtube.com/embed/UMOjNUBqV08?si=t68CHL9vb3MArh_j' }
        ],
        audio: [
            { url: 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/1986901600&color=%23fe6148&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true' }
        ],
        link: 'https://archeryevolution.io'
    },
    {
        title: 'fabulous crisis',
        publisher: 'aramis marcuola-bel',
        roles: [
            { role: 'composer' },
            { role: 'koreographer editing' }
        ],
        published: 'TBA',
        description: 'A VR rhythm game in early development inspired by classic rhythm games such as Space Channel 5, Parappa the Rapper, and Dance Dance Revolution.',
        banner: `${process.env.PUBLIC_URL}/images/banners/fc-banner.png`,
        videos: [
            { name: 'trailer', url: '' },
            { name: 'gameplay', url: '' },
            { name: 'showreel', url: '' },
        ],
        audio: [
            {
                url: 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2127714981&color=%23fe6148&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true'
            }
        ],
        link: ''
    },
    {
        title: 'project break//down',
        publisher: 'fist face studios',
        roles: [
            { role: 'composer' }
        ],
        published: 'TBA',
        description: 'Project: Break//Down is an experimental 3D action-adventure brawler with a unique limb-based combat system that allows for satisfying combat. In this game you explore the EZON complex, a mass production and distribution facility secretly gone rogue in the shoes of 2 fools.',
        banner: `${process.env.PUBLIC_URL}/images/banners/pbd-banner.jpg`,
        screenshots: [
            { url: `${process.env.PUBLIC_URL}/images/screenshots/project-break-down/1.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/project-break-down/2.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/project-break-down/3.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/project-break-down/4.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/project-break-down/5.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/project-break-down/6.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/project-break-down/7.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/project-break-down/8.jpg` },
        ],
        videos: [
            { name: 'trailer', url: '' },
            { name: 'gameplay', url: 'https://www.youtube.com/embed/nBJnDgGC50A?si=2Jg5DbEV92skKrCR' },
            { name: 'showreel', url: '' },
        ],
        audio: [
            { url: 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/1946440231&color=%23fe6148&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true' }
        ],
        link: 'https://store.steampowered.com/app/2317220/Project_BreakDown/'
    },
    {
        title: 'bubblemancer',
        publisher: 'n/a',
        roles: [
            { role: 'composer' },
            { role: 'sound designer' },
            { role: 'godot implementation' }
        ],
        published: '26.01.2025',
        description: 'Wrestle with the arcane mysteries of Alchemy via the blowing of eldritch bubbles - break the seals, complete your formulae, or be consumed!',
        banner: `${process.env.PUBLIC_URL}/images/banners/bubblemancer-banner.png`,
        screenshots: [
            { url: `${process.env.PUBLIC_URL}/images/screenshots/bubblemancer/1.jpg` },
        ],
        videos: [
            { name: 'showreel', url: '' },
        ],
        audio: [
            { url: 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/2049141057&color=%23fe6148&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true' }
        ],
        link: 'https://globalgamejam.org/games/2025/bubblemancer-1-0'
    },
    {
        title: 'night of the living ooze',
        publisher: 'winterwire games',
        roles: [
            { role: 'composer' },
            { role: 'sound designer' },
            { role: 'voice actor' },
            { role: 'fmod implementation' },
        ],
        published: '21.08.2024',
        description: 'You play as a living ooze that hungers for all, flings chunks of itself at enemies, and thirsts for the size to consume the entire universe.',
        banner: `${process.env.PUBLIC_URL}/images/banners/notlo-banner.png`,
        screenshots: [
            { url: `${process.env.PUBLIC_URL}/images/screenshots/notlo/1.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/notlo/2.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/notlo/3.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/notlo/4.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/notlo/5.jpg` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/notlo/6.jpg` },
        ],
        videos: [
            { name: 'trailer', url: 'https://www.youtube.com/embed/hBZbkPj30Uo?si=JO_S_Bj8H0CgXwLU' },
            { name: 'gameplay', url: '' },
            { name: 'showreel', url: '' },
        ],
        audio: [
            { url: 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/2049125913&color=%23fe6148&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true' }
        ],
        link: 'https://winterwiregames.itch.io/night-of-the-living-ooze'
    },
    {
        title: 'surely you jest?!',
        publisher: 'winterwire games',
        roles: [
            { role: 'composer' },
            { role: 'sound designer' },
            { role: 'voice actor' },
            { role: 'fmod implementation' },
        ],
        published: '28.01.2024',
        description: "Surely you Jest?! is a Physics-Based extravaganza of gags, pranks, and more as you, The King's court Jester, are commanded to make the King and his guests laugh till their sides hurt.",
        banner: `${process.env.PUBLIC_URL}/images/banners/syj-banner.png`,
        screenshots: [
            { url: `${process.env.PUBLIC_URL}/images/screenshots/syj/1.png` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/syj/2.png` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/syj/3.png` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/syj/4.png` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/syj/5.png` },
        ],
        videos: [
            { name: 'trailer', url: 'https://www.youtube.com/embed/rhylxlBMGeE?si=o6c8m8thiDD1ZgC_' },
            { name: 'gameplay', url: '' },
        ],
        audio: [
            { url: 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/2049148053&color=%23fe6148&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true' }
        ],
        link: 'https://winterwiregames.itch.io/surely-you-jest'
    },
    {
        title: 'a balanced breakfast',
        publisher: 'winterwire games',
        roles: [
            { role: 'composer' },
            { role: 'sound designer' },
            { role: 'voice actor' },
            { role: 'fmod implementation' },
        ],
        published: '10.07.2023',
        description: "Help your dear old grannie make some breakfast in this Role-Reversed Puzzle Game filled with stylish pixel art, bopping chip-tune beats, and just the right amount of challenge!",
        banner: `${process.env.PUBLIC_URL}/images/banners/aba-banner.png`,
        screenshots: [
            { url: `${process.env.PUBLIC_URL}/images/screenshots/breakfast/1.png` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/breakfast/2.png` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/breakfast/3.png` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/breakfast/4.png` },
        ],
        videos: [
            { name: 'trailer', url: '' },
            { name: 'gameplay', url: '' },
        ],
        audio: [
            { url: 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/2049152646&color=%23fe6148&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true' }
        ],
        link: 'https://winterwiregames.itch.io/a-balanced-breakfast'
    },
    {
        title: 'jimmy blitz and the rocket dice',
        publisher: 'team dovecoat',
        roles: [
            { role: 'composer' }
        ],
        published: '18.07.2022',
        description: "We’re pullin’ the biggest casino heist in history, boss. Let’s dominate some games and take home the money with your ROCKET-POWERED DICE!",
        banner: `${process.env.PUBLIC_URL}/images/banners/jbrd-banner.png`,
        screenshots: [
            { url: `${process.env.PUBLIC_URL}/images/screenshots/jimmy-blitz/1.png` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/jimmy-blitz/2.png` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/jimmy-blitz/3.png` },
        ],
        videos: [
            { name: 'trailer', url: 'https://www.youtube.com/embed/cDXtcY1boXo?si=1_Db3AkJjevwRbAQ' },
            { name: 'gameplay', url: '' },
        ],
        audio: [
            { url: 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/2049057063&color=%23fe6148&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true' }
        ],
        link: 'https://thegoodowl.itch.io/rocketdice'
    },
    {
        title: 'nest quest',
        publisher: 'team dovecoat',
        roles: [
            { role: 'composer' }
        ],
        published: '25.07.2021',
        description: "Time to get crackin'! Roll, bounce, and fling yourself back to your nest in over 15 egg-citing levels!",
        banner: `${process.env.PUBLIC_URL}/images/banners/nestquest-banner.png`,
        screenshots: [
            { url: `${process.env.PUBLIC_URL}/images/screenshots/nest-quest/1.png` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/nest-quest/2.png` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/nest-quest/3.png` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/nest-quest/4.png` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/nest-quest/5.png` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/nest-quest/6.png` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/nest-quest/7.png` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/nest-quest/8.png` },
            { url: `${process.env.PUBLIC_URL}/images/screenshots/nest-quest/9.png` },
        ],
        videos: [
            { name: 'trailer', url: '' },
            { name: 'gameplay', url: '' },
        ],
        audio: [
            { url: 'https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/2049054126&color=%23fe6148&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true' }
        ],
        link: 'https://www.newgrounds.com/portal/view/807185'
    },
];

export default projects;
